export default __webpack_public_path__ + "static/finance-presentation-by-fbdbb4ad376417e76078c736b2d8b3fa.png";